import MentalMomentum from './MentalMomentum';
export default MentalMomentum;
